import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// import useChecklist from '../../hooks/useChecklist';
import useAuth from "../../hooks/useAuth";

import Screen from "../../components/Screen";
import SubmitButton from "../../components/SubmitButton";
import NewOptions from "./NewOptions";
import ReviewButtons from "./ReviewButtons";
import ChecklistDetails from "./ChecklistDetails";
import ChecklistQuestions from "./ChecklistQuestions";
import appContext from "../../app/contextState/context";
import { ChecklistContext } from "../../hooks/checklistContext";
import AlertSetup from "./alertSetup";

const NewChecklist = () => {
  //('hi')
  const location = useLocation();
  const { isAdmin } = useAuth();
  // const state = useContext(appContext);
  // const { loading } = state;
  const {
    loading,
    collection,
    data,
    question,
    setData,
    setQuestion,
    fetchChecklists,
    onAddQuestiuon,
    newChecklist,
    changeChecklist,
    removeChecklist,
    sendForReview,
    approveReview,
    rejectReview,
    onDublicateQuestiuon
  } = useContext(ChecklistContext);

  // states
  const [showQuestions, setShowQuestions] = useState(false);
  const [showReportSetup, setShowReportSetup] = useState(false);
  const update = location?.search.split("?update=")[1];
  // Constants
  const checklistID = location.state?.data?._id;
  const disabled =
    // data?.questions?.length == 0 ||
    !data?.title || !data?.checklistFrequency || !data?.categoryID;

  useEffect(() => {
    if (checklistID) fetchChecklists({ id: checklistID });
  }, []);

  useEffect(() => {
    if (loading != "fetch" && location.state?.data) {
      setData(collection?.find((item) => item?._id == checklistID));
    }
  }, [update]);

  useEffect(() => {
    if (!location.state?.data) {
      setData({
        title: "",
        checklistFrequency: "Daily",
        checklistReport: "None",
        notificationFrequency: { date: Date.now(), times: [Date.now()] },
        reportFrequency: { date: Date.now(), times: [Date.now()] },
        questions: [],
      });
    }

  }, []);

  return (
    <Screen
      loading={loading == "fetch"}
      faqsId={"add_checklist"}
      flow={[
        { label: "Checklist", to: "/checklists" },
        { label: "Home", to: "/checklists" },
        { label: "Collection", to: "/checklists" },
        {
          label: !!location.state?.data ? "Update Checklist" : "New Checklist",
          to: "/new-checklist",
        },
      ]}
    >
      {location?.state == null ? (
        <NewOptions />
      ) : (
        <section className="section profile">
          <div className="row">
            <form action="" className="row">
              {/* Submit Button */}
              <div className="d-flex justify-content-end mb-3 gap-3">
                {!showQuestions && !showReportSetup ? null : (
                  <SubmitButton
                    title={"Back"}
                    onClick={() => {
                      setShowQuestions(false)
                      setShowReportSetup(false)
                    }}
                    color={"outline-primary"}
                    icon={<i className="bi bi-arrow-left "></i>}
                  />
                )}
                {data?.companyID && (
                  <ReviewButtons
                    loading={loading}
                    data={data}
                    sendForReview={sendForReview}
                    rejectReview={rejectReview}
                    approveReview={approveReview}
                  />
                )}
                {isAdmin && data?.status == "pending" ? null : (
                  <>
                    <SubmitButton
                      title={"Save Checklist"}
                      loading={loading == "new" || loading == "update"}
                      onClick={() =>
                        location.state?.update
                          ? changeChecklist()
                          : newChecklist()
                      }
                      color={"success"}
                      loaderColor={"white"}
                      disabled={disabled}
                    />
                    {!location.state?.data ? null : (
                      <SubmitButton
                        icon={<i className="bi bi-trash3"></i>}
                        loading={loading == "delete"}
                        onClick={() => removeChecklist()}
                        color={"danger"}
                        loaderColor={"white"}
                        disabled={disabled}
                      />
                    )}
                  </>
                )}
              </div>
              {showQuestions || showReportSetup ? null : (
                <ChecklistDetails data={data} setData={setData} />
              )}
              {!showReportSetup ? null : (
                <AlertSetup data={data} setData={setData} />
              )}
              {!showQuestions ? null : (
                <ChecklistQuestions
                  data={data}
                  setData={setData}
                  question={question}
                  setQuestion={setQuestion}
                  onAddQuestiuon={onAddQuestiuon}
                  onDublicateQuestiuon={onDublicateQuestiuon}
                />
              )}
              {showReportSetup || showQuestions ? null : (
                <div
                  className="d-flex justify-content-center align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowQuestions(false)
                    setShowReportSetup(true)
                  }}
                >
                  <span className="card-title text-center">Setup Report</span>
                  <i className="bi bi-arrow-right card-title text-center"></i>
                </div>
              )}
              {showQuestions || showReportSetup ? null : (
                <div
                  className="d-flex justify-content-center align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowReportSetup(false)
                    setShowQuestions(true)
                  }}
                >
                  <span className="card-title text-center">View Questions</span>
                  <i className="bi bi-arrow-right card-title text-center"></i>
                </div>
              )}
            </form>
          </div>
        </section>
      )}
    </Screen>
  );
};

export default NewChecklist;
